import { Component, OnInit } from '@angular/core';
import { UtilitieService } from 'src/app/services/utils/utilities.service';

@Component({
  selector: 'instructions',
  templateUrl: './instructions.component.html',
  styleUrls: ['./instructions.component.css']
})
export class InstructionsComponent implements OnInit{


  constructor(private utilService: UtilitieService) {
  }
  ngOnInit(): void {

    this.utilService.updateLoading(true);
  }

}
